import type { NotificationChannelGroupManager } from './NotificationChannelGroupManager.types';

export default {
  addListener: () => {},
  removeListeners: () => {},
} as NotificationChannelGroupManager;
